var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoParentalRatingAdult = function SvgIcoParentalRatingAdult(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2.399,
    d: "M12 20.396a8.396 8.396 0 1 0 0-16.792 8.396 8.396 0 0 0 0 16.792Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.438 8.577c-.37-.375-.873-.415-1.33.04l-2.076 2.077-2.119-2.117c-.53-.535-.996-.296-1.287 0l-.015.009c-.37.375-.415.878.044 1.332l2.075 2.078-2.119 2.115c-.531.537-.291.999 0 1.295l.015.008c.37.374.874.416 1.332-.04l2.074-2.077 2.119 2.117c.531.534.998.295 1.287 0l.009-.008c.379-.376.414-.879-.037-1.334l-2.074-2.076 2.111-2.117c.537-.536.299-.999 0-1.293z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIcoParentalRatingAdult;